import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import MyInput from '../../components/forms/input'
import MyButton from '../../components/forms/button'

export default function Login() {
    const navigate = useNavigate()
    const [formValue, setFormValue] = useState({})
    const [errorMsg, setErrorMsg] = useState({})

    const handleSubmit = () => {
        setErrorMsg({})
        if (!formValue.username) {
            setErrorMsg({ usernameEmpty: '用户名不能为空' })
            return
        }
        if (!formValue.password) {
            setErrorMsg({ passwordEmpty: '密码不能为空' })
            return
        }

        axios.post('/admin/account/login', {
            username: formValue.username,
            password: formValue.password
        })
            .then((response) => {
                if (response.errcode === 0) {
                    localStorage.setItem('token', response.data.access_token)
                    navigate('/enterprise_entry')
                } else if (response.errcode === 1) {
                    setErrorMsg({ usernameError: response.msg })
                } else if (response.errcode === 2 || response.errcode === 3) {
                    setErrorMsg({ pwdError: response.msg })
                }
            })
            .catch((error) => {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <img className="login-logo" src="/images/logo.png" alt="logo" />
                    <p className="login-description">兰州职业技术学院就业系统管理后台</p>
                </div>

                <form className="login-form">
                    <MyInput
                        id="username"
                        autoFocus
                        autoComplete='on'
                        label="用户名"
                        placeholder='请输入用户名'
                        value={formValue.username}
                        onChange={setFormValue}
                        errorMsg={errorMsg.usernameEmpty || errorMsg.usernameError}
                    />
                    <MyInput
                        id="password"
                        type="password"
                        visibilityToggle={false}
                        label="密码"
                        onPressEnter={handleSubmit}
                        placeholder='请输入密码'
                        value={formValue.password}
                        onChange={setFormValue}
                        errorMsg={errorMsg.passwordEmpty || errorMsg.pwdError}
                    />

                    <MyButton
                        onClick={handleSubmit}
                        buttonText='登录'
                        style={{ width: '200px', marginTop: '30px' }}
                    />
                </form>
            </div>
        </div>
    )
}